export default () => ({
    showFurtherInfoModal: false,
    activeTabIndex: 0,

    init() {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                this.showFurtherInfoModal = false
            }
        }

        this.$watch('showFurtherInfoModal', (open) => {
            if (open) {
                document.addEventListener('keydown', handleEscape)
            } else {
                document.removeEventListener('keydown', handleEscape)
            }
        })

        document.addEventListener('size-guide-modal:open', () =>
            this.openModal('sizeGuideModal')
        )
    },

    openModal(ref) {
        const dialog = this.$refs[ref]

        if (!dialog) {
            throw new Error('Dialog element not found')
        }

        const dialogInner = dialog.firstElementChild

        dialog.showModal()

        const handleClickOutside = (e) => {
            if (!dialogInner.contains(e.target)) {
                dialog.close()
            }
        }

        dialog.addEventListener('click', handleClickOutside)

        const cleanUpListeners = () => {
            dialog.removeEventListener('click', handleClickOutside)
            dialog.removeEventListener('close', cleanUpListeners)
        }

        dialog.addEventListener('close', cleanUpListeners)
    },
    closeModal() {
        const trigger = this.$el
        const dialog = trigger.closest('dialog')

        if (!dialog) {
            throw new Error('Dialog element not found')
        }

        dialog.close()
    },
})
